<template>
    <div class="login-container">
      <div class="login-box">
        <h2>登录</h2>
        <div class="form-group">
          <label for="password">密码：</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            @keyup.enter="handleLogin"
            placeholder="请输入密码"
            class="password-input"
          />
        </div>
        <button @click="handleLogin" class="login-btn">登录</button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginComponent',
    data() {
      return {
        password: '',
        errorMessage: ''
      };
    },
    methods: {
      handleLogin() {
        if (this.password === 'crowd2025') {
          // 登录成功，保存到localStorage
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('loginTime', Date.now().toString());
          this.$router.push('/');
        } else {
          this.errorMessage = '密码错误，请重试';
          this.password = '';
        }
      }
    }
  };
  </script>
  
<style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: url('../assets/login/background.jpg') no-repeat center center;
    background-size: cover;
  }
  
  .login-box {
    background: white;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
  }
  
  .login-box h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #2c3e50;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    color: #2c3e50;
    font-weight: 500;
  }
  
  .password-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
  }
  
  .password-input:focus {
    outline: none;
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
  
  .login-btn {
    width: 100%;
    padding: 12px;
    background: #409eff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .login-btn:hover {
    background: #337ecc;
  }
  
  .error-message {
    color: #f56c6c;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
  }
</style>